import { v4 } from 'uuid';
import { executeTwoStepEventQueries, exposeEvent, fetchJsonByGet } from './execute';
import { getParams } from '../reducers/analyticsApp';
import { createOthersQuery, createQuery } from '../utils/event/createQueries';
import { createEvents } from '../converters/eventConverter';
import {
  createEventsQueries,
  fromEventResponse,
  getEventsInfo,
} from '../converters/eventApiConverter';
import { applyCache } from '../utils/event/cacheHandler';

export const fetchMetainf = () => (dispatch, getState) =>
  fetchJsonByGet('/metainf', getParams(getState())).then((response) => ({
    metainf: createEvents(response),
  }));

export const executeEventQueries = (executeId) => (dispatch, getState) => {
  const state = getState();
  const eventQueries = createEventsQueries(state);
  const eventsInfo = getEventsInfo(state);

  const execute = (queries) => executeTwoStepEventQueries(queries, executeId, dispatch, getState);

  return applyCache(eventQueries, execute, dispatch, getState).then((response) => {
    return fromEventResponse(response, eventQueries, eventsInfo);
  });
};

export const exposeEventQuery = (id, clauseId) => (dispatch, getState) => {
  const state = getState();
  const query = clauseId ? createOthersQuery(state, id, clauseId) : createQuery(state, id);
  return exposeEvent(query, v4(), dispatch, getState).then((response) => ({
    sql: response,
    id,
  }));
};
